import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
interface ConsultContextValue {
  isOpen: boolean;
  source: string;
  openConsult: (source?: string) => void;
  closeConsult: () => void;
}
const ConsultContext = createContext<ConsultContextValue | null>(null);
export function ConsultProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [source, setSource] = useState('site');
  const openConsult = useCallback((nextSource = 'site') => {
    setSource(nextSource);
    setIsOpen(true);
  }, []);
  const closeConsult = useCallback(() => setIsOpen(false), []);
  const value = useMemo(() => ({
    isOpen,
    source,
    openConsult,
    closeConsult
  }), [isOpen, source, openConsult, closeConsult]);
  return <ConsultContext.Provider value={value} data-id="element-242" data-mp="3hiwno3of6z0x">{children}</ConsultContext.Provider>;
}
export function useConsult(): ConsultContextValue {
  const ctx = useContext(ConsultContext);
  if (!ctx) throw new Error('useConsult must be used within a ConsultProvider');
  return ctx;
}